import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import PublicIcon from '@mui/icons-material/Public';
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";


const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};
const menuItems = [
  { title: "Dashboard", to: "/", icon: <DashboardIcon /> },
  { title: "Manage Team", to: "/team", icon: <GroupIcon />, category: "Data" },
  { title: "Profile Form", to: "/form", icon: <AccountBoxIcon />, category: "Pages" },
  { title: "FAQ Page", to: "/faq", icon: <LiveHelpIcon />, category: "Pages" },
  { title: "Bar Chart", to: "/bar", icon: <InsertChartIcon />, category: "Charts" },
  { title: "Pie Chart", to: "/pie", icon: <PieChartIcon />, category: "Charts" },
  { title: "Line Chart", to: "/line", icon: <ShowChartIcon />, category: "Charts" },
  { title: "Geography Chart", to: "/geography", icon: <PublicIcon />, category: "Charts" },
];


const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Update isCollapsed based on screen size
  useEffect(() => {
    setIsCollapsed(isMobile);
  }, [isMobile]);

  return (
    <div
      initial={{ width: isCollapsed ? "80px" : "350px" }}
      animate={{ width: isCollapsed ? "80px" : "350px" }}
      transition={{ type: "spring", stiffness: 30 }}
      style={{ height: "100%" }}
    >
      <Box
        sx={{
          "& .pro-sidebar-inner": {
            background: `${colors.primary[400]} !important`,
          },
          "& .pro-icon-wrapper": {
            backgroundColor: "transparent !important",
          },
          "& .pro-inner-item": {
            padding: "5px 35px 5px 20px !important",
          },
          "& .pro-inner-item:hover": {
            color: "#868dfb !important",
          },
          "& .pro-menu-item.active": {
            color: "#6870fa !important",
          },
        }}
      >
        <ProSidebar collapsed={isCollapsed}>
          <Menu iconShape="square">
            {/* LOGO AND MENU ICON */}
            <MenuItem
              onClick={() => setIsCollapsed(!isCollapsed)}
              icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
              style={{
                margin: "10px 0 20px 0",
                color: colors.grey[100],
              }}
            >
              {!isCollapsed && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  ml="15px"
                >
                  <Typography variant="h3" color={colors.grey[100]}>
                    RDB
                  </Typography>
                  <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                    <MenuOutlinedIcon />
                  </IconButton>
                </Box>
              )}
            </MenuItem>

            <Box paddingLeft={isCollapsed ? undefined : "10%"}>
              {menuItems
                .filter((item) => !item.category)
                .map(({ title, to, icon }) => (
                  <Item
                    key={title}
                    title={title}
                    to={to}
                    icon={icon}
                    selected={selected}
                    setSelected={setSelected}
                  />
                ))}

              {["Data", "Pages", "Charts"].map((category) => (
                <Box key={category}>
                  <Typography
                    variant="h6"
                    color={colors.grey[300]}
                    sx={{ m: "15px 0 5px 20px" }}
                  >
                    {category}
                  </Typography>
                  {menuItems
                    .filter((item) => item.category === category)
                    .map(({ title, to, icon }) => (
                      <Item
                        key={title}
                        title={title}
                        to={to}
                        icon={icon}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    ))}
                </Box>
              ))}
            </Box>
          </Menu>
        </ProSidebar>
      </Box>
    </div>
  );
};

export default Sidebar;
